var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "collections" },
    [
      _vm._l(_vm.groups, function(ref, idxGroup) {
        var collection = ref.collection
        return [
          idxGroup === _vm.selectGroup
            ? _c(
                "SliderButtons",
                {
                  key: "group" + idxGroup,
                  attrs: { options: _vm.swiperOption }
                },
                _vm._l(collection, function(ref, idx) {
                  var image = ref.image
                  var title = ref.title
                  return _c(
                    "swiper-slide",
                    { key: "col" + idx },
                    [
                      _c("CollectionCard", {
                        attrs: {
                          image: image,
                          "is-play": _vm.isPlayed[idxGroup][idx],
                          title: title
                        },
                        on: {
                          "update:isPlay": function($event) {
                            return _vm.$set(_vm.isPlayed[idxGroup], idx, $event)
                          },
                          "update:is-play": function($event) {
                            return _vm.$set(_vm.isPlayed[idxGroup], idx, $event)
                          },
                          playPause: function(isPlay) {
                            return _vm.onPlayPause(idxGroup, idx, isPlay)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(collection, function(ref, idxAudio) {
            var music = ref.music
            return _c("audio", {
              key: "aud" + idxGroup + "-" + idxAudio,
              ref: _vm.audioRef(idxGroup, idxAudio),
              refInFor: true,
              attrs: {
                src: music,
                crossorigin: "anonymous",
                loop: "loop",
                preload: "none"
              }
            })
          })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }